module.exports = __webpack_public_path__ + "static/media/gb.6dcadf69.svg";